export const SubscriptionTypeMap: Record<string, string> = Object.freeze({
  everyday: 'Everyday',
  alternate: 'Alternate Days',
  custom: 'Custom Days',
});
